import UserEdit from "screens/components/UserEdit"
import { useUrl, getAdminOrgId }  from "lib/site"

function AdminUserCreate() {
    const getUrl = useUrl();
    return <UserEdit organisationId={getAdminOrgId()} returnUrl={getUrl("AdminUsers")} />

}

export default AdminUserCreate;